export * from './lib/portals-notifications.module';
export * from './lib/portals-socket-notifications.service';
